// extracted by mini-css-extract-plugin
export default {"statsContainer":"WeeklyStats_statsContainer__UKzfb","statItem":"WeeklyStats_statItem__rqpJG","statLabel":"WeeklyStats_statLabel__Fkt0B","statValue":"WeeklyStats_statValue__f7jtP"};